import React, { Fragment, useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Container } from '@material-ui/core'
import { Header } from './components/Header/Header'
import { useRoutes } from './routes'
import { SnackBar } from './components/SnackBar/SnackBar'
import { refreshToken } from './store/actions/auth/sign'
import { Loader } from './components/Loader/Loader'
import { setIsReady } from './store/actions/app/setIsReady'

const App = () => {
  const isReady = useSelector((state) => state.auth.isReady)
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)
  const dispatch = useDispatch()

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('token'))
    token ? dispatch(refreshToken(token)) : dispatch(setIsReady())
  }, [dispatch])
  const routes = useRoutes(isAuthenticated)
  if (!isReady) {
    return <Loader />
  }
  return (
    <Fragment>
      <Router>
        <SnackBar />
        {isAuthenticated && <Header />}
        <Container maxWidth={isAuthenticated ? 'lg' : 'xs'}>{routes}</Container>
      </Router>
    </Fragment>
  )
}
export default App
